// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e os
// carregadores das telas. Outro módulo usa a `public.ts`.
export { loadBankAccountRequestMessages } from './bank-account-request.catalog';
export { BANK_ACCOUNT_REQUEST_TABS, bankAccountRequestDetailScreen, bankAccountRequestDetailSearch, type BankAccountRequestTab } from './bank-account-request-detail.screen';
export { BANK_ACCOUNT_REQUEST_LIST_PATH, bankAccountRequestListScreen, bankAccountRequestListSearch } from './bank-account-request-list.screen';

/** Cada tela no próprio chunk: a lista não carrega o formulário do detalhe, e o detalhe não carrega a lista. */
export const loadBankAccountRequestListScreen = () => import('./screens/request-list-screen');
export const loadBankAccountRequestDetailScreen = () => import('./screens/request-detail-screen');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadBankAccountRequestGuides = () => import('./bank-account-request.guide');
